import { useEffect } from 'react';

/**
 * PlausibleAnalytics - Bindet Plausible Analytics cookieless ein.
 *
 * Liest Konfiguration aus Umgebungsvariablen:
 *   NEXT_PUBLIC_PLAUSIBLE_DOMAIN   - Die zu trackende Domain (z.B. "paperball.de")
 *   NEXT_PUBLIC_PLAUSIBLE_API_HOST - (optional) Third-Party-Host-Override
 *   NEXT_PUBLIC_PLAUSIBLE_SCRIPT   - (optional) Script-Pfad, Default /js/script.js
 *
 * Standard (121WATT-Fleet): first-party Auslieferung über den nginx-Proxy
 * (/js/script.js + /api/event → geteilte Plausible-Instanz). Das ist
 * adblock-resistent UND CSP-konform (die nginx-CSP erlaubt script-src
 * 'self'; ein Third-Party-Host würde geblockt). Nur wenn API_HOST gesetzt ist
 * wird third-party geladen (dann muss die CSP entsprechend gelockert werden).
 *
 * Das Skript wird per `document.createElement` eingehängt, nicht als
 * `<script>` im JSX: React 19 legt ein gerendertes `<script>` ohne `async`
 * zwar in den Kopf, führt es aber nie aus. So stand nach der Next.js-Umstellung
 * (03.10.2026) das Tag mit richtiger Domain im Kopf, und es kam kein einziges
 * Ereignis an. Wächter: `test_plausible_laedt_canon.py`.
 *
 * Ohne NEXT_PUBLIC_PLAUSIBLE_DOMAIN wird nichts geladen (Analytics aus).
 * Plausible erkennt SPA-Navigation automatisch; cookieless & DSGVO-konform.
 */
const SKRIPT_ID = 'plausible-analytics';

export default function PlausibleAnalytics() {
  useEffect(() => {
    const domain = process.env.NEXT_PUBLIC_PLAUSIBLE_DOMAIN;
    if (!domain || document.getElementById(SKRIPT_ID)) {
      return;
    }

    const apiHost = process.env.NEXT_PUBLIC_PLAUSIBLE_API_HOST;
    const skript = document.createElement('script');
    skript.id = SKRIPT_ID;
    skript.defer = true;
    skript.dataset.domain = domain;
    skript.src = apiHost
      ? `${apiHost}/js/script.js`
      : (process.env.NEXT_PUBLIC_PLAUSIBLE_SCRIPT || '/js/script.js');
    skript.onerror = () => console.error('Plausible-Skript nicht ladbar:', skript.src);
    document.head.appendChild(skript);
  }, []);

  return null;
}
